import { DateTime, type DateTimeFormatOptions } from 'luxon';

const defaultFormat: DateTimeFormatOptions | string = 'yyyy-MM-dd';

export default function getStartAndEndDate(
  start: string,
  end: string,
  formatFn: (dates?: [string, string]) => DateTimeFormatOptions | string = () =>
    defaultFormat,
) {
  const startDateObj = DateTime.fromISO(start);
  const endDateObj = DateTime.fromISO(end);
  const chosenFormat = formatFn([start, end]);

  return [
    startDateObj.toFormat(chosenFormat as string),
    endDateObj.toFormat(chosenFormat as string),
  ];
}
